import { useQuerySpecialties } from '@/hooks/query/useQuerySpecialties';

export const useTemplateSpecialties = () =>
  useQuerySpecialties((data) => data.specialties);
